class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    this.blockId = this.getAttribute('data-block-id');

    this.handleSubmit = this.handleSubmit.bind(this);
    this.liveValidation = this.liveValidation.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.inputTelegram = this.querySelector('[data-telegram-input]');
    this.tagsInput = this.querySelector(`#customer-tags-${this.blockId}`);

    if (this.form && this.inputTelegram && this.tagsInput) {
      // Live validation for Telegram username
      this.inputTelegram.addEventListener('input', this.liveValidation);

      // Populate tags before form submit
      this.form.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    if (this.inputTelegram) this.inputTelegram.removeEventListener('input', this.liveValidation);
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  liveValidation() {
    const value = this.inputTelegram.value.trim();
    const isValid = /^@[\w\d_]{3,32}$/.test(value);

    if (!isValid) {
      this.inputTelegram.setCustomValidity('Please enter a valid Telegram username starting with @');
    } else {
      this.inputTelegram.setCustomValidity('');
    }
  }

  handleSubmit(event) {
    const telegramUsername = this.inputTelegram.value.trim();
    if (telegramUsername) {
      this.tagsInput.value = `telegram-${telegramUsername}`;
    }
  }
}

// Define custom element
if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
